import { defineComponent, type PropType, reactive } from 'vue'
import CellMixin from '../CellMixin'
import { useRefresh } from '../../hooks/useTableRefresh'
import { message, Switch } from 'ant-design-vue'
import type { IConfig } from '../../types'
export default defineComponent({
  name: 'StateCell',
  mixins: [CellMixin],
  props: {
    enableFn: {
      type: Object as PropType<IConfig['enableAction']>,
      default: null
    },
    disableFn: {
      type: Object as PropType<IConfig['disableAction']>,
      default: null
    },
    record: {
      type: Object as PropType<{ id: string; isOpen: number }>,
      default: null
    },
    text: {
      type: Number as PropType<number>,
      default: null
    }
  },
  setup(props) {
    const { refreshTable } = useRefresh()

    const state = reactive({
      loading: false
    })
    const handleChange = async (checked: Boolean) => {
      state.loading = true
      try {
        await (checked ? props.enableFn?.fn : props.disableFn?.fn)?.({
          ids: [props.record.id as string]
        })
        // eslint-disable-next-line vue/no-mutating-props
        props.record.isOpen = +checked
        message.success('更新状态成功')
        refreshTable()
      } catch (err) {
        message.error('更新状态失败')
      }
      state.loading = false
    }
    // @ts-ignore
    return () => <Switch checked={props.text === 1} onChange={handleChange} />
  }
})
